<template>
    <v-layout column fill-height>
        <breadcrumbs guia="Movimentação de Vidas" titulo="Movimentação de Vidas" descricao="Faça a movimentação de vidas, consulte histórico e crie relatórios" />
        <v-layout class="main">
            <Vidas />
            <!-- <MovimentacaoVidas 
            :parentVue="this.parentVue"
            :codigoCorretor="this.usuario.codCorretor != null ? this.usuario.codCorretor : '0'" 
            :emailUsuario="(this.usuario.emailAuxiliar != null && this.usuario.emailAuxiliar != '') ? this.usuario.emailAuxiliar : this.usuario.email" /> -->
        </v-layout>

        <!-- <v-dialog v-model="dialog" max-width="420">
            <v-card>
              <v-card-title class="headline">Comunicado Importante</v-card-title>
              <v-card-text>
                <img src="/upload/comunicado_importante-envio_documentos.png" alt="Comunicado Importante" class="popup-image" />
              </v-card-text>
              <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="dialog = false">OK</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog> -->
    </v-layout>
</template>

<script>
import Helpers from "@/utilities/Helpers";
import Vue from 'vue';
import { mapGetters } from 'vuex';

import breadcrumbs from "@/components/portal/layout/Breadcrumbs";
import Vidas from "@/components/portal/movimentacao-vidas/Vidas";

export default {
  name: 'view-movimentacao-vidas',
  components: {
    breadcrumbs,
    Vidas
  },
  mixins: [Helpers],  
  data() {
    return {
      parentVue: Vue,
      dialog: false
    }
  },  
  computed: {
  ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
  },  
  mounted() {
    this.dialog = true;
  } 
};
</script>

<style lang="scss">
    .popup-image {
        max-width: 100%;
        max-height: 100%;
    }
    .select-tipo-coluna{
        min-width: 250px;
    }
    .v-data-table.border {
        overflow: auto !important;
        max-height: 400px;
        td, th {
            border-right:1px solid #dddddd;
            border-left:1px solid #dddddd;
        }
        th{
            border-top:1px solid #dddddd;
            background: #eeeeee;
            padding-top: 30px;
        }        
        .v-data-table__wrapper{
            overflow-x: auto !important;
            overflow-y: auto !important;
            max-height: 400px;
        }
    }
    .alert{
        color: #ffffff;
        padding: 10px;
        margin:2px;
        border-radius: 3px;
        -moz-border-radius: 3px;
        -webkit-border-radius: 3px;
        &.enviado{
            background: #76AB3C;
        }
        &.processando{
            background: #2a4469;
        }
        &.faturado{
            background: #4FB5DD;
        }
        &.sem-movimentacao{
            background: #555555;
        }
    }
</style>